import type { TaxonomyField } from '@/entities/taxonomy';

/** The fields with one bound field set to emit each option's display value as its code. */
export function withDisplayValuesAsCodes(
  fields: TaxonomyField[],
  fieldId: string,
): TaxonomyField[] {
  return fields.map((f) =>
    f.id === fieldId && f.listRef ? { ...f, listRef: { ...f.listRef, codeColumnId: null } } : f,
  );
}
